module.exports = __webpack_public_path__ + "54cf98f5/img/file-icon.c085e21e.svg";